import { render } from "./ContinueDrugs.vue?vue&type=template&id=18624666&scoped=true"
import script from "./ContinueDrugs.vue?vue&type=script&lang=js"
export * from "./ContinueDrugs.vue?vue&type=script&lang=js"

import "./ContinueDrugs.vue?vue&type=style&index=0&id=18624666&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18624666"]])

export default __exports__